// The BrainTap character cast — 28 AI-illustrated portraits in /public/avatars.
// Each player picks one; `kind` stores the id.
export const AVATARS = [
  { id: "cat", name: "Cat" },
  { id: "dog", name: "Dog" },
  { id: "fox", name: "Fox" },
  { id: "wolf", name: "Wolf" },
  { id: "horse", name: "Horse" },
  { id: "unicorn", name: "Unicorn" },
  { id: "dragon", name: "Dragon" },
  { id: "owl", name: "Owl" },
  { id: "penguin", name: "Penguin" },
  { id: "frog", name: "Frog" },
  { id: "bunny", name: "Bunny" },
  { id: "panda", name: "Panda" },
  { id: "tiger", name: "Tiger" },
  { id: "lion", name: "Lion" },
  { id: "octopus", name: "Octopus" },
  { id: "alien", name: "Alien" },
  { id: "robot", name: "Robot" },
  { id: "goblin", name: "Goblin" },
  { id: "pirate", name: "Pirate" },
  { id: "viking", name: "Viking" },
  { id: "knight", name: "Knight" },
  { id: "princess", name: "Princess" },
  { id: "fairy", name: "Fairy" },
  { id: "elf", name: "Elf" },
  { id: "wizard", name: "Wizard" },
  { id: "witch", name: "Witch" },
  { id: "dwarf", name: "Dwarf" },
  { id: "hobbit", name: "Hobbit" },
];

export function avatarById(id) {
  return AVATARS.find((a) => a.id === id) || null;
}

export const COLOR_HEX = {
  amber: "#f5b335",
  mint: "#34d8a8",
  coral: "#ff5a82",
  ice: "#dce8ff",
  grape: "#b18cff",
  tang: "#ff9a5a",
};

export function avatarHex(color) {
  return COLOR_HEX[color] || COLOR_HEX.amber;
}

// Stable pick for legacy configs (old memoji shape) — same config, same character.
export function pickAvatarId(config) {
  if (config && config.kind && avatarById(config.kind)) return config.kind;
  try {
    const s = JSON.stringify(config || {});
    let h = 0;
    for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
    return AVATARS[h % AVATARS.length].id;
  } catch (e) {
    return "cat";
  }
}
